import { ApiRouts } from '@/src/routes/routes';
import { IDigitalCard } from '@/src/types/digitalCards';
import HttpCLient from '@/src/lib/utils/httpClient';
import { ResponseProductDetailsType } from '../../stores/[store]/[storeId]/product/service/getProductDetails';

type DigitalCardsPrams = {
  Page?: string;
  PageCount?: string;
  SearchKey?: string;
  CategoryId?: string;
};

export type DigitalCardCategoriesResponse = {
  id: number;
  englishName: string;
  arabicName: string;
  branchId: string;
  countryId: number;
  currencyCode: string;
};

export const DIGITAL_PAGE_SIZE = 25;

class digitalCardsServices extends HttpCLient {
  getDigitalCards = async (params?: DigitalCardsPrams) => {
    const defalutParams = {
      ...params,
      Page: params?.Page || '1',
      PageCount: params?.PageCount || DIGITAL_PAGE_SIZE.toString(),
    };

    return await this.get<IDigitalCard[]>(ApiRouts.digitalCards, defalutParams);
  };

  // details
  getDigitalCardDetails = async (id: string) =>
    await this.get<IDigitalCard>(ApiRouts.digitalCardDetails(id));

  // get the degital card  categories
  getDegitalCardCategories = async () =>
    await this.get<DigitalCardCategoriesResponse[]>(ApiRouts.digitalCardCategories);
}

export const DigitalCardsServices = new digitalCardsServices();
